/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { VerifiedIcon } from '../../../../../images/icons/Verified/Verified'
import { currency } from '../../../../common/CurrencyFormat'

export const AddressDetails = (props: any) => (
    <div className={`addressBlock__content addressBlock__content--details`}>
        <div className="addressBlock__addressType">{props.addressType}</div>
        <div className="addressBlock__details">
            <span>{props.addressLine1}</span>
            <span>{props.addressLine2}</span>
            <span>{props.city}</span>
            <span>{props.postcode}</span>
            {(props.countryName) ? <span>{props.countryName}</span> : ''}
            {(props.addressAllocated) ? <span className="allocated">{currency(props.addressAllocated)}</span> : null}
        </div>
        <hr />

        {
            /**
             * Print verified badge if address is security checked
             */
            props.securityVerified ? <VerifiedBadge /> : null}

        {
            /**
             * If address is security checked
             */
            (props.securityVerified && !props.hideDeleteLocation) ? (
                <div
                    className="addressBlock__verify addressBlock__verify--delete"
                    onClick={() => props.triggerDelete(props.id)}
                >
                    Remove address
                </div>
            ) : null}

        {
            /**
             * If address is security checked and this is the only address
             */
            (props.securityVerified && props.hideDeleteLocation) ? (
                <div
                />
            ) : null}

        {
            /**
             * If address is NOT security checked
             */
            (!props.securityVerified) ? (
                <div className="addressBlock__verify" onClick={props.triggerVerify} >
                    Use this address
            </div>
            ) : null}
    </div>
)

/**
 * Verified Badge
 */
const VerifiedBadge = () => (
    <div className="addressBlock__verified">
        <VerifiedIcon />
    </div>
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step02/components/AddressDetails.tsx